export const GetRootElement: () => HTMLElement | null = () => document.getElementById("app-root");
